import { render, staticRenderFns } from "./TestReportResult.vue?vue&type=template&id=2b4b5aa0&scoped=true"
import script from "./TestReportResult.vue?vue&type=script&lang=js"
export * from "./TestReportResult.vue?vue&type=script&lang=js"
import style0 from "./TestReportResult.vue?vue&type=style&index=0&id=2b4b5aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b5aa0",
  null
  
)

export default component.exports